import React from 'react';

export const initialState = {
    opened: true
};


export function reducer(state, action) {
    switch (action.type) {
      case 'SET_MENU':
        return {
          ...state,
          opened: action.opened
        };
      default:
        return state;
    }
};

export const dispatch = React.createContext(null);